export const sanitizeParallelArrays = (obj, keys) => {
  if (!obj || !keys || keys.length === 0) return {};

  const firstKey = keys[0];
  if (!Array.isArray(obj[firstKey])) return {};

  const length = obj[firstKey].length;
  
  const sanitized = {};
  keys.forEach(key => {
    sanitized[key] = [];
  });
  
  for (let i = 0; i < length; i++) {    
    const isRowValid = keys.every(key => {
      const value = obj[key]?.[i];
      return value !== null && value !== undefined && value !== '';
    });
   
    if (isRowValid) {
      keys.forEach(key => {
        sanitized[key].push(obj[key][i]);
      });
    } else {      
      console.warn(`[Sanitize] Linha inválida descartada no índice ${i}:`, 
        keys.reduce((acc, k) => ({ ...acc, [k]: obj[k]?.[i] }), {})
      );
    }
  }

  return sanitized;
};